<template>
  <div class="el-container-table alarm-rule-container"
       v-loading="refreshloading">
    <el-table :data="tableData"
              tooltip-effect="light"
              @filter-change="changeFilter"
              :empty-text="tableEmptyTip"
              style="width: 100%">
      <el-table-column :label="$t('alarmHistory.alarmRuleName')"
                       min-width="140px"
                       show-overflow-tooltip>
        <template slot-scope="scope">
          <a href="javascript:void(0)"
             @click="showRulesDetail(scope.row,'detail')"
             class="a-link-text">{{scope.row.name}}</a>
        </template>
      </el-table-column>
      <el-table-column min-width="140px"
                       :label="$t('alarmHistory.ipAndPort')">
        <template slot-scope="scope">
          <el-tooltip placement="top"
                      effect="dark">
            <div slot="content"
                 v-if="scope.row.switchboard && scope.row.switchboard.length > 0">
              <span v-for="(item,index) in scope.row.switchboard"
                    :key="index">
                {{item.ip }} <br />{{item.port }}<br />
              </span>
            </div>
            <div v-if="scope.row.switchboard && scope.row.switchboard.length > 0">
              {{scope.row.switchboard[0].ip }} <br />{{scope.row.switchboard[0].port }}
              <div v-if="scope.row.switchboard.length > 1">...</div>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="condition"
                       min-width="200px"
                       :label="$t('alarmHistory.alarmCondition')">
      </el-table-column>
      <el-table-column prop="noticePeriodName"
                       :label="$t('alarmHistory.notificationPeriod')">
      </el-table-column>
      <el-table-column :label="$t('alarmHistory.notificationPersion')">>
        <template slot-scope="scope">
          <el-button type="text"
                     @click="showNotificationInfo(scope.row)"
                     size="small">{{$t('text.check')}}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="statusName"
                       :filter-multiple="false"
                       :filters="rulesStatusFilters"
                       columnKey="status"
                       :filter-method="filtersMethod"
                       :label="$t('alarmHistory.ruleStatus')">
      </el-table-column>
      <el-table-column prop="address"
                       :label="$t('text.operate')">
        <template slot-scope="scope">
          <el-button type="text"
                     @click="showRulesDetail(scope.row,'history')"
                     size="small">{{$t('alarmHistory.alarmHistory')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="el-page-footer el-container-table-actionBar"
         v-if="tableData.length > 0">
      <el-pagination @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="pageSizes"
                     :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="totalItems">
      </el-pagination>
    </div>
    <notification :visible.sync="notifyVisible"
                  :notifyArray="notifyArray"
                  :tips="true"
                  :firstLabel="firstLabel"
                  :secindLabel="secindLabel"
                  :firstArray="firstArray"
                  :secindArray="secindArray"
                  v-if="notifyVisible"></notification>
  </div>
</template>
<script>
import notification from '../../alarm/opt/Notification';

export default {
  components: {
    notification
  },
  data () {
    return {
      currentPage: 1,
      pageSize: 20,
      pageSizes: [20, 50, 100],
      totalItems: 0,
      tableData: [],
      tableEmptyTip: this.$t('text.noSearch'),
      refreshloading: false, // 刷新
      notifyVisible: false,
      filtersValue: {
        status: ''
      },
      notifyArray: [{
        label: this.$t('alarmHistory.contactsPeople'),
        value: 'firstLabel'
      }, {
        label: this.$t('alarmHistory.contactsGroup'),
        value: 'secindLabel'
      }],
      firstLabel: [{
        label: this.$t('text.fullName'),
        value: 'userName'
      }, {
        label: this.$t('alarmHistory.phone'),
        value: 'mobile'
      }, {
        label: this.$t('text.email'),
        value: 'email'
      }],
      secindLabel: [{
        label: this.$t('alarmHistory.contactsGroupName'),
        value: 'groupName'
      }, {
        label: this.$t('alarmHistory.groupNumber'),
        value: 'personNum'
      }],
      firstArray: [],
      secindArray: [],
    };
  },
  mounted () {
    this.getAlarmRulesList();
  },
  props: {
    bandwidthId: {
      type: [String, Number],
      required: true
    },
    idcId: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    alarmFilters () {
      return this.$store.state.alarmFilters.alarmFilterList;
    },
    rulesStatusFilters () {
      if (!this.alarmFilters.status) return;
      return this.alarmFilters.status;
    }
  },
  methods: {
    getAlarmRulesList (params) {
      const tempParams = {
        resourceType: 'bandwidth',
        resourceId: this.bandwidthId,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
      };
      this.refreshloading = true;
      const newParams = params || tempParams;
      this.$api.listAlarms(newParams).then((res) => {
        if (res.errno === 10000 && res.errmsg === 'OK' && res.data) {
          this.tableData = res.data.alarms;
          this.totalItems = res.data.totalCount;
        }
      }).catch(() => {
        this.tableData = [];
      }).finally(() => {
        this.refreshloading = false;
      });
    },

    // 查看通知对象
    async showNotificationInfo ({ alarmId }) {
      const contactPersons = await this.$api.getListAlarmContactPersons({ alarmId });
      const contactGroups = await this.$api.getListAlarmContactGroups({ alarmId });
      this.firstArray = contactPersons.data.contactPersons;
      this.secindArray = contactGroups.data.contactGroups;
      this.notifyVisible = true;
    },

    showRulesDetail (row, tabName) {
      this.$router.push({
        path: `/alarmrules/detail/${row.alarmId}`,
        query: { tabName: `${tabName}` }
      });
    },

    // 下拉筛选
    changeFilter (arg) {
      Object.keys(arg).forEach((key) => {
        if (key === 'status') {
          this.filtersValue[key] = arg[key][0] || '';
        }
      });
      // false 不保留页数 从第一页开始
      this.handleWithFliter(false);
    },

    handleWithFliter (type) {
      if (!type) {
        this.currentPage = 1;
      }
      let params = {
        resourceType: 'bandwidth',
        resourceId: this.bandwidthId,
        pageSize: this.pageSize,
        pageNumber: this.currentPage
      };
      this.tableEmptyTip = this.$t('text.noSearch');

      // 下拉搜索部分请求参数
      Object.keys(this.filtersValue).forEach((key) => {
        if (this.filtersValue[key].length) {
          if (key === 'status') {
            params = { ...params, status: this.filtersValue[key] };
            this.tableEmptyTip = this.$t('text.hasSearch');
          }
        }
      });
      this.getAlarmRulesList(params);
    },

    filtersMethod () {
      return true;
    },

    handleSizeChange (val) {
      this.pageSize = val;
      // true 保留页数不置1
      this.handleWithFliter(true);
    },

    handleCurrentChange (val) {
      this.currentPage = val;
      // true 保留页数不置1
      this.handleWithFliter(true);
    },
  }
};
</script>
<style lang="scss" scoped>
.a-link-text {
  color: #2aaffc;
}
.alarm-rule-container {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.alarm-rule-container /deep/ .el-table {
  flex: 1;
  min-height: 0;
}
.alarm-rule-container .el-page-footer {
  position: static;
  margin-top: auto;
  flex-shrink: 0;
}
.el-page-footer {
  padding: 0 !important;
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/bandwidthTraffic/opt/AlarmRules.vue